import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import Swal, { SweetAlertResult } from 'sweetalert2';
import { NgbDateParserFormatter, NgbModal, NgbModalOptions, NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
export const commonModal: NgbModalOptions = {
  centered        : true,
  backdrop        : "static",
  keyboard        : false,
  size            : "md",
};
export const ModalPopupSize = {
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl',
  XXL: 'xxl',
}


@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(private modalService: NgbModal, private http: HttpClient, public toaster?: ToastrService, public offcanvasService?: NgbOffcanvas,public ngbDateParserFormatter?: NgbDateParserFormatter) { }
  openModalPopup(component: any, data: any, title: any, popupSize: string = ModalPopupSize.LG, windowClass: string = "", fullscreen?: boolean, centered?: boolean): Promise<any> {
    commonModal.size = popupSize;
    commonModal.windowClass = windowClass;
    commonModal.fullscreen = fullscreen;
    commonModal.centered = centered??true;

    const modalOption: NgbModalOptions = {
      ...commonModal,
    };
    const modalRef = this.modalService.open(component, modalOption);
    if (title != undefined)
      modalRef.componentInstance.modalTitle = title;
    modalRef.componentInstance.data = data;
    return modalRef.result.then(
      (result) => {
        if (result) {
          return result;
        }
      },
      (reason) => {
        return null;
      }
    );
  }
    convertTOngbDate(date:any){
    const dateObj = new Date(date);
    const offset = dateObj?.getTimezoneOffset();
    dateObj.setMinutes(dateObj?.getMinutes() - offset);
    const ngbDate: any = this.ngbDateParserFormatter?.parse(dateObj?.toISOString());
    return ngbDate;
  } 


  sucesspopup(message) {
    Swal.fire({
      position: 'top-right',
      width: 350,
      heightAuto: false,
      icon: 'success',
      text: message,
      showConfirmButton: false,
      timer: 1500
    })
  }

 
  loadSvgIcon(filePath: string): Observable<string> {
    return this.http.get(filePath, { responseType: 'text' });
  }


  
  confirmationPopup(title, subtitle, icon, showDenyButton = true, confirmButtonText = 'Yes', denyButtonText = `No`, showDeleteButton = false) {
    var subject = new Subject<SweetAlertResult>();
    this.loadSvgIcon('assets/svg/Common_Popup_Component_Icons/' + icon + '.svg').subscribe((svgContent) => {
          console.log(svgContent);

      Swal.fire({
        title: title,
        html: '<p class="sub-info font-regular text-gray d-flex align-items-center f-14 mb-2 justify-content-center text-center  border-color-white">' + subtitle + '</p>',
        iconHtml: svgContent,
        showDenyButton: showDenyButton,
        showCancelButton: showDeleteButton,
        showCloseButton: true,
        width: 300,
        confirmButtonText: confirmButtonText,
        denyButtonText: denyButtonText,
        // cancelButtonText: showDontSaveButton ? dontSaveButtonText : deleteButtonText,
        customClass: {
          title: 'sweetAlertTitle',
          htmlContainer: 'swalHtml',
          confirmButton: 'swal-custom-confirm-button', // Yes button
          denyButton: 'swal-custom-deny-button',
          cancelButton: 'swal-custom-deny-button',       // No button
          actions: 'swal-custom-actions',
        },
        // confirmButtonColor: '#3085d6'
      }).then((result) => {
        if (result?.isDismissed && (result?.dismiss === Swal?.DismissReason.close || result?.dismiss === Swal?.DismissReason?.backdrop)) {
          subject.next(result); //close button click && backdrop click
        } else if (result?.isConfirmed) {
          subject.next(result);  // Yes button click
        } else if (result?.isDenied) {
          subject.next(result);  // No button click
        } else if (result?.dismiss === Swal?.DismissReason?.cancel) {
          subject.next(result);  // Don't Save or Cancel button click
        }
      });
    });
    return subject.asObservable();
  }


}